// @flow
import React from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { DBG_BUILD } from 'config/index';

type Props = {
	currentUser:   ?Object,
	navbarButtons: Array,
};

// Sticky wrapper that pins its content (the tab bars) directly below the
// fixed app header. Offsets mirror the header stack in containers/Root:
//
//   DBG "DEVELOPMENT MODE" banner : DBG_H (sticky, top: 0,    z-index: 103)
//   HamburgerMenu logo bar        : LOGO_H (sticky,            z-index: 101)
//   Navbar (only if buttons set)  : NAVBAR_H (sticky,          z-index: 100)
//
// The tabs must stick at the BOTTOM edge of whatever header is visible,
// otherwise they slide under (and get hidden by) the higher-z header.
export const DBG_H    = 1.4;   // dev-mode banner height (rem)
export const LOGO_H   = 3.0;   // HamburgerMenu logo bar height (rem)
export const NAVBAR_H = 2.7;   // Navbar bar height (rem)

export const stickyTop = (navbarPresent: boolean) => {
	let top = LOGO_H;               // logo bar is always pinned at the top
	if (DBG_BUILD)     top += DBG_H;
	if (navbarPresent) top += NAVBAR_H;
	return `${top}rem`;
};

const StickyHeader = ({ style, children, ...rest }) => {

	const headerVisible = (rest.currentUser !== null) && (rest.navbarButtons.length > 0);

	return (
		<View
			style={{
				position:        'sticky',
				top:             stickyTop(headerVisible),
				zIndex:          99,      // below Navbar (100) and logo bar (101)
				backgroundColor: '#fff',  // so scrolled content doesn't show through
				...style,
			}}>
			{children}
		</View>
	);
};

export default connect(
	(state) => ({
		currentUser:   state.session.currentUser,
		navbarButtons: state.navbar.buttons,
	})
)(StickyHeader);
